import { Injectable } from '@angular/core';

declare var grecaptcha: any;
const siteKey = '6LdKsHwcAAAAAMKeX0bWRSkGuvH6wLAQ-j1cBTmu';

@Injectable()
export class CaptchaService {

  constructor() { }

  public generateCaptchaToken(action): Promise<string> {
    return new Promise((res, rej) => {
      grecaptcha.ready(() => {
        grecaptcha.execute(siteKey, { action: action }).then((token) => {
          return res(token);
        });
      });
    });
  }
}
